// Français pour la boîte de dialogue d'acquittement — clore un engagement avec sa preuve.
import { registerFr } from '../i18n/index.js';

registerFr({
  '{ref} discharged — the ball moves.': '{ref} acquitté — la balle avance.',
  'Discharge {ref}': 'Acquitter {ref}',
  'made {date}': 'fait le {date}',
  'owner {owner}': 'responsable {owner}',
  'unrecorded': 'non renseigné',
  'Discharged on — the date the promise was kept': 'Acquitté le — la date à laquelle la promesse a été honorée',
  "Evidence — what kept it. Exactly one, and it must be this client's.": 'Preuve — ce qui l’a honorée. Exactement une, et elle doit appartenir à ce client.',
  'A document': 'Un document',
  'An event': 'Un événement',
  '— pick the document that kept the promise —': '— choisir le document qui a honoré la promesse —',
  '— pick the event that kept the promise —': '— choisir l’événement qui a honoré la promesse —',
  'Note — optional, one line on how it was kept': 'Note — facultatif, une ligne sur la manière dont elle a été honorée',
  'Cancel': 'Annuler',
  'Recording…': 'Enregistrement…',
  'Record the discharge': 'Enregistrer l’acquittement',
}, 'DischargeModal');
